import maskPhoneNumber from '@lib/utils/maskPhoneNumber';
import { Chip, Text, Tooltip } from '@servicetitan/anvil2';
import strings from '../../strings';
import styles from './OutboundCallerIdConfirmationHeader.module.css';
import classNames from 'classnames';

const MAX_MEMO_TOOLTIP_LENGTH = 21;

export const OutboundCallerIdConfirmationHeader = ({
  customerName,
  customerNumber,
  memo,
  className,
}: {
  customerName?: string;
  customerNumber: string;
  memo?: string;
  className?: string;
}) => {
  const customerDisplayPhone = maskPhoneNumber(customerNumber);

  return (
    <div className={classNames(styles.section, className)}>
      <Text variant='headline' size='medium' el='h3'>
        {`${strings.labels.toPrefix} ${customerName ?? ''}`}
      </Text>
      <div className={styles.customerInfo}>
        <Text variant='body' size='medium' className={styles.phone}>
          {customerDisplayPhone}
        </Text>
        {memo && (
          <Tooltip>
            <Tooltip.Trigger className={styles.memoTooltip}>
              {<Chip label={memo} size='medium' className={styles.memo} />}
            </Tooltip.Trigger>
            {memo.length > MAX_MEMO_TOOLTIP_LENGTH && (
              <Tooltip.Content className={styles.tooltipWrapper}>
                {memo}
              </Tooltip.Content>
            )}
          </Tooltip>
        )}
      </div>
    </div>
  );
};
